export default "__VITE_ASSET__ODa69cwr__"